import { SETTINGS_LEGAL_AGREEMENTS_PATH } from "@app/routes";
import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router";
import { Banner, Box, IconCheckCircle } from "../shared";

export const SettingsLegalAgreementsCallbackPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [secondsLeft, setSecondsLeft] = useState(5);

  const rawAgreementStatus = searchParams.get("agreementStatus");
  const isSuccess = [null, "", "completed"].includes(rawAgreementStatus);
  const isFailure = !isSuccess;

  useEffect(() => {
    if (!isSuccess) return;
    try {
      const message = {
        source: "adobeSign",
        event: "completed",
        agreementStatus: rawAgreementStatus ?? "completed",
      };
      window.parent?.postMessage(message, window.location.origin);
      window.opener?.postMessage(message, window.location.origin);
    } catch {
      // no-op
    }
  }, [isSuccess, rawAgreementStatus]);

  useEffect(() => {
    if (!isSuccess) return;
    const id = window.setInterval(() => {
      setSecondsLeft((s) => {
        if (s <= 1) {
          window.clearInterval(id);
          queueMicrotask(() => navigate(SETTINGS_LEGAL_AGREEMENTS_PATH));
          return 0;
        }
        return s - 1;
      });
    }, 1000);
    return () => window.clearInterval(id);
  }, [isSuccess, navigate]);

  if (isFailure) {
    return (
      <div className="flex flex-col items-center justify-center gap-4 py-8 px-4">
        <Banner variant="error" className="max-w-md">
          We could not confirm that your agreement was completed. You can return
          to Legal & Compliance to check the status or try again.
        </Banner>
        <Link
          to={SETTINGS_LEGAL_AGREEMENTS_PATH}
          className="text-indigo underline"
        >
          Return to Agreements
        </Link>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center py-8">
      <Box className="flex max-w-md flex-col items-center gap-4 text-center">
        <IconCheckCircle variant="lg" color="#00633F" aria-hidden />
        <p className="text-lg font-medium text-gray-900">Agreement signed</p>
        <p className="text-gray-600">
          You will be redirected to the Agreements page in {secondsLeft}{" "}
          {secondsLeft === 1 ? "second" : "seconds"}.
        </p>
      </Box>
    </div>
  );
};
